import React, { Fragment } from "react";
import { InView } from "react-intersection-observer";

export const InfiniteScroll = ({
    children,
    loaderComponent,
    next,
    ...props
}) => {
    return (
        <Fragment {...props}>
            {children}
            <InView
                as="div"
                onChange={(inView, entry) => {
                    if (inView) {
                        next();
                    }
                }}
            >
                {React.cloneElement(loaderComponent)}
            </InView>
        </Fragment>
    );
};
